import fiftyLogo from 'shared/static/images/logo-green.svg';
import styled from 'styled-components';

const locale = {
  en: {
    fiftyFooter_poweredBy: 'Powered by',
  },
  is: {
    fiftyFooter_poweredBy: 'Knúið af',
  },
  pl: {
    fiftyFooter_poweredBy: 'Powered by',
  },
  no: {
    fiftyFooter_poweredBy: 'Powered by',
  },
  sv: {
    fiftyFooter_poweredBy: 'Powered by',
  },
  fr: {
    fiftyFooter_poweredBy: 'En partenariat avec',
  },
};

export default function FiftyFooter({ lang }) {
  return (
    <Wrapper>
      <div>
        <a href="https://www.50skills.com">
          <img src={fiftyLogo} alt="50skills logo" />
          <div>
            {locale[lang].fiftyFooter_poweredBy}
            <div>50skills</div>
          </div>
        </a>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  box-sizing: border-box;
  color: #00c882;
  background-color: rgba(0, 0, 0, 0.03);
  flex: 0 0 128px;
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 1080px) {
    padding: 0 20px;
  }

  > div {
    margin: 0 auto;
    width: 100%;
    max-width: 980px;
    height: 32px;

    > a {
      font-size: 14px;
      display: flex;
      > div > div {
        font-weight: bold;
      }
    }

    > a > img {
      height: 32px;
      width: 32px;
      margin-right: 7px;
    }
  }
`;
